'use client';

import forbiddenImage from '@fdc/../public/fdc-images/errors/errorImage.png';
import BasePageContainer from '@fdc/components/layout/base-page-container/base-page-container';
import { NAVIGATION_CONSTANTS } from '@fdc/constants/navigation.constants';
import { useAppRouter } from '@fdc/hooks/useAppRouter';
import { openChatWidget } from '@fdc/utils/chat-widget';
import CoreButton from '@woolworthslimited/core-components-react/button/button';
import { useWindowDimension } from '@woolworthslimited/core-components-react/shared/hooks/useWindowDimension';
import { isMediumDeviceOrGreater } from '@woolworthslimited/core-components-react/shared/services/breakpoint/breakpoint.service';

import styles from '../../not-found.module.scss';

export default function ProductDetailsForbidden() {
  const router = useAppRouter();
  const [width] = useWindowDimension(false);
  const largeDevice = isMediumDeviceOrGreater(width);

  const ErrorCTAs = () => {
    return (
      <div className={styles.actions}>
        <CoreButton
          as="a"
          label="Go to home page"
          variant="primary"
          size="medium"
          isFullWidth={width && !largeDevice}
          clickHandler={() => router.push(NAVIGATION_CONSTANTS.HOME_PAGE)}
        ></CoreButton>
        <CoreButton
          as="a"
          label="Chat with Olive"
          variant="secondary"
          size="medium"
          isFullWidth={width && !largeDevice}
          clickHandler={openChatWidget}
        ></CoreButton>
      </div>
    );
  };

  return (
    <BasePageContainer>
      <div className={styles['not-found-container']}>
        <img
          className={styles['error-image']}
          src={forbiddenImage.src}
          aria-hidden="true"
          alt="forbidden"
        />
        <div className={styles['error-panel']}>
          <h1>This is a restricted item</h1>
          <p className={styles['error-code']}>403</p>
          <p>
            Tobacco, alcohol, and other restricted items will not show unless
            you’re over 18 and signed in.
          </p>
          <p>
            You can continue shopping other products, or contact us through
            Olive for help.
          </p>
        </div>
        {<ErrorCTAs />}
      </div>
    </BasePageContainer>
  );
}
